import { render, staticRenderFns } from "./OverallStatPanel.vue?vue&type=template&id=fece29d0&lang=pug&"
import script from "./OverallStatPanel.vue?vue&type=script&lang=js&"
export * from "./OverallStatPanel.vue?vue&type=script&lang=js&"
import style0 from "./OverallStatPanel.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports